import { ChangeDetectionStrategy, Component } from "@angular/core";
import { LookerRiskDashboardType } from "../../looker-risk-dashboard-type.enum";
import { HideFilters } from "../../models/analytics-hide-filters.enum";

@Component({
  selector: "app-contacts-report-dw",
  templateUrl: "./contacts-report-dw.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactsReportDWComponent {
      filters: string[] = ["Projects"];
      dashboardType = LookerRiskDashboardType.CONTACTS_REPORT;
      hideFilters: string[] = [HideFilters.USER_ID2, HideFilters.ORG_ID, HideFilters.PROJECT_ID, HideFilters.PROJECT_NAME2, HideFilters.CLIENT_NAME, HideFilters.CONTACT_METHOD_ID];
}

